import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import List from "app/stores/list"

export default class Store {
  @observable keywords = ""

  @action updateFamily = (familyId, name) => {
    return request.put(`${config.backend}/pgd/family/${familyId}`)
    .send({name})
    .checkToken()
    .commonDispose()
  }

  @action getHistory = (familyId) => {
    return request.get(`${config.backend}/pgd/family/${familyId}/history`)
    .checkToken()
    .commonDispose()
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "pgd/family")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/pgd/dataManage.js